import { ScalarObject } from '@things-factory/shell'
import { ObjectType, Field, InputType, ID, Int } from 'type-graphql'
import { KpiScope, ScopeType } from './kpi-scope'

@InputType()
export class NewKpiScope {
  @Field(type => Int, { description: 'Scope level (1-5) corresponding to scope01-scope05 in KpiOrgScope' })
  level: number

  @Field({ description: 'Display name for this scope dimension (e.g., "지역", "회사", "프로젝트규모")' })
  name: string

  @Field({ nullable: true, description: 'Detailed description of what this scope dimension represents' })
  description?: string

  @Field(type => ScopeType, { description: 'Type category of this scope dimension' })
  scopeType: ScopeType

  @Field(type => Int, { nullable: true, description: 'Parent scope level if this forms a hierarchy' })
  parentLevel?: number

  @Field(type => Int, { description: 'Order/priority for display and processing', defaultValue: 1 })
  displayOrder: number

  @Field(type => [String], { nullable: true, description: 'List of valid values for this scope' })
  validValues?: string[]

  @Field({ nullable: true, description: 'Regex pattern for validating values in this scope dimension' })
  validationPattern?: string

  @Field({ description: 'Whether this scope definition is active and should be used', defaultValue: true })
  active: boolean

  @Field({ description: 'Whether this scope should be included in statistical calculations', defaultValue: true })
  includeInStatistics: boolean

  @Field({ description: 'Whether this scope should be displayed in dashboard visualizations', defaultValue: false })
  showInDashboard: boolean

  @Field(type => ScalarObject, { nullable: true, description: 'Additional metadata for this scope dimension' })
  metadata?: any
}

@InputType()
export class KpiScopePatch {
  @Field(type => ID, { nullable: true })
  id?: string

  @Field(type => Int, { description: 'Scope level (1-5) corresponding to scope01-scope05 in KpiOrgScope' })
  level: number

  @Field({ description: 'Display name for this scope dimension (e.g., "지역", "회사", "프로젝트규모")' })
  name: string

  @Field({ nullable: true, description: 'Detailed description of what this scope dimension represents' })
  description?: string

  @Field(type => ScopeType, { description: 'Type category of this scope dimension' })
  scopeType: ScopeType

  @Field(type => Int, { nullable: true, description: 'Parent scope level if this forms a hierarchy' })
  parentLevel?: number

  @Field(type => Int, { description: 'Order/priority for display and processing', defaultValue: 1 })
  displayOrder: number

  @Field(type => [String], { nullable: true, description: 'List of valid values for this scope' })
  validValues?: string[]

  @Field({ nullable: true, description: 'Regex pattern for validating values in this scope dimension' })
  validationPattern?: string

  @Field({ description: 'Whether this scope definition is active and should be used', defaultValue: true })
  active: boolean

  @Field({ description: 'Whether this scope should be included in statistical calculations', defaultValue: true })
  includeInStatistics: boolean

  @Field({ description: 'Whether this scope should be displayed in dashboard visualizations', defaultValue: false })
  showInDashboard: boolean

  @Field(type => ScalarObject, { nullable: true, description: 'Additional metadata for this scope dimension' })
  metadata?: any

  @Field({ nullable: true })
  cuFlag?: string
}

@ObjectType()
export class KpiScopeList {
  @Field(type => [KpiScope])
  items: KpiScope[]

  @Field()
  total: number
}
